import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import React from "react";
import i18n from "../i18n-config";
import theme from "../theme/theme";
import { capitalizeFirstLetter } from "../utils/strings";
import CustomButton from "./CustomButton";

interface Props {
  visible: boolean;
  title: string;
  onClose?(): void;
  onConfirm?(): void;
}

export default function CustomConfirm({
  visible,
  title = i18n.t("quit_page"),
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          textAlign={"center"}
        >
          {title}
        </DialogContentText>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 30,
          }}
        >
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("cancel"))}
            rootStyle={{ width: "45%", backgroundColor: theme.colors.primary }}
            onClick={onClose}
          />
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("confirm"))}
            rootStyle={{
              backgroundColor: "transparent",
              border: "1px solid black",
              width: "45%",
            }}
            titleStyle={{ color: "black" }}
            onClick={onConfirm}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
